<template>
  <div>
    <div v-if="!user.grant.payments">
      <div class="h-screen flex w-full bg-img">
          <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
              <img src="@/assets/images/pages/404.png" alt="graphic-404" class="mx-auto mb-4 max-w-full">
              <h1 class="sm:mx-0 mx-4 mb-12 text-3xl d-theme-heading-color">404 - Page introuvable!</h1>
              <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-heading-color">La page que vous demandez est introuvable</p>
          </div>
      </div>
    </div>
    <div v-else>
      <alter
        :isSidebarActive="showSidebar"
        :data="sidebarData"
        @closeSidebar="toggleSidebar"
        :editEl="editEl"
        :callBackAdd="callBackAdd"
        :specialitiesPop="specialities"
        @updateData="updateDataInfo"
        :agents="agents"
      />
      <detail
        :isPromptActive="filterPrompt"
        @closePrompt="toggleFilterPrompt"
        :information="information"
      />
      <reSend
        :isPromptActive="filterPromptCode"
        @closePrompt="toggleFilterPromptCode"
      />
      <div class="custom__card">
        <div class="header__ mb-2">
          <h6>Filtre</h6>
        </div>
        <div class="card__body">
          <div>
            <vs-select
              class="w-full"
              label="Statut"
              icon="arrow_downward"
              v-model="model.namespace"
              autocomplete
              >
              <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in status" />
            </vs-select>
          </div>
          <div>
            <vs-select
              class="w-full"
              label="Spécialité"
              icon="arrow_downward"
              v-model="model.speciality"
              autocomplete
              >
              <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in specialities" />
            </vs-select>
          </div>
          <div style="height: 37px"
            @click="getFilter()"
            class="mt-6 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary">
            <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Filtrer</span>
          </div>
          <div style="height: 37px"
            @click="filterPromptCode = true"
            class="mt-6 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary">
            <feather-icon icon="SendIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Renvoyer le code</span>
          </div>
        </div>
      </div>
      <vs-table
        ref="table"
        :max-items="10"
        :data="data"
      >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <div class="flex flex-wrap-reverse items-center data-list-btn-container">
            <div
              @click="reload()"
              class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary">
              <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Actualiser</span>
            </div>
          </div>
          <div class="con-input-search vs-table--search">
            <input placeholder="Rechercher par code" @keyup.enter="getSearch()" v-model="model.search" type="text" class="input-search vs-table--search-input">
            <i class="vs-icon notranslate icon-scale material-icons null">search</i>
          </div>
        </div>

        <template slot="thead">
          <vs-th>Code consultation</vs-th>
          <vs-th>Date de paiement</vs-th>
          <vs-th>Statut</vs-th>
          <vs-th>Specialité</vs-th>
          <vs-th>Nom & prénom</vs-th>
          <vs-th>Montant payé (Fcfa)</vs-th>
          <vs-th>Numéro payeur</vs-th>
          <vs-th>Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td width="20%">
              <span class="">{{ tr.code }} </span>
            </vs-td>
            <vs-td width="20%">
              <span class="">{{ parseDate(tr.paid_at) }} </span>
            </vs-td>

            <vs-td>
              <vs-chip v-if="tr.status == 'to_validate'" color="success">Validé</vs-chip>
              <vs-chip v-if="tr.status == 'to_canceled'" color="danger">Annulé</vs-chip>
              <vs-chip v-if="tr.status == 'expired'" color="danger">Expiré</vs-chip>
              <vs-chip v-if="tr.status == 'paid'">Nouveau</vs-chip>
            </vs-td>

            <vs-td width="20%">
              <p class="product-category">{{ tr.speciality ? tr.speciality : '' }}</p>
            </vs-td>

            <vs-td width="20%">
              <p class="product-category">{{ tr.last_name ? tr.last_name : '' }} {{ tr.first_name ? tr.first_name : '' }}</p>
            </vs-td>

            <vs-td width="20%">
              <p class="product-category">{{ parseFormat(tr.amount) }}</p>
            </vs-td>

            <vs-td width="20%">
              <p class="product-category">{{ tr.phone }}</p>
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <div class="flex">
                <vx-tooltip text="Imprimer">
                  <feather-icon style="cursor:pointer"
                    @click="printerData(tr)"
                    icon="PrinterIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
                <vx-tooltip text="Modifier">
                  <feather-icon v-if="tr.first_name != null && tr.last_name != null && user.profile == '2' " style="cursor:pointer"
                    @click="editData(tr)"
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
                <vx-tooltip text="Detail">
                  <feather-icon @click="showDetail(tr)" style="cursor:pointer"
                    icon="EyeIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <vs-pagination v-if="last_page && model.page" :total="last_page" v-model="model.page"></vs-pagination>
    </div>
  </div>
</template>

<script>
import { _buildQuery, format } from '../../helper/helper'
import detail from './item/detail.vue'
import reSend from './item/code.vue'
import moment from 'moment'
import Alter from './item/alter.vue'
const default_model = {
  page: 1,
  namespace:'',
  search: '',
  speciality: ''
}
export default {
  components:{
    detail, reSend,
    Alter
  },
  watch: {
   'model.page': function() {
     this.getData();
   }
  },
  data: () => ({
    information:{},
    last_page: 1,
    filterPrompt: false,
    filterPromptCode: false,

    showSidebar: false,
    sidebarData: {},
    editEl: false,

    data: [],
    model:{
      page: 1,
      namespace:'',
      search: '',
      speciality: ''
    },
    specialities:[],
    user: {},
    valideData: {},
    agents: [],
    status:[
      {name: 'Tous', id: ''},
      {name: 'Nouveau', id: 'paid'},
      {name: 'Validé', id: 'to_validate'},
      {name: 'Annulé', id: 'to_canceled'},
      {name: 'Expiré', id: 'expired'},
    ],
    practiciens: []
  }),
  created(){
    this.user = JSON.parse(localStorage.getItem('user_cnhu'))
  },
  mounted(){
    if (this.user.grant.payments){
      this.getData()
      this.getSpecialities()
    }
  },
  methods:{
    toggleSidebar(val = false) {
      this.showSidebar = val;
    },
    editData(element){

      this.editEl = true
      this.sidebarData = { ...element }
      this.valideData = element
      this.getAgent()
    },
    callBackAdd(element){
      const index = this.data.findIndex(this.valideData)
      this.data.splice(index, 1, element)
    },

    updateDataInfo(element = {}){
      const index = this.data.indexOf(this.valideData)
      this.data.splice(index, 1, element)
    },

    printerData(tr){
      this.$vs.loading()
      this.$http.post('/payments/print', {id: tr.id}, {
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = link.href = url
        const name = tr.code+'.pdf'
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
        this.$vs.loading.close()
      }).catch((error) => {
        this.$vs.loading.close()
        if (error.response.status === 401) {
          this.$vs.notify({
            title: 'Erreur',
            text: 'Votre session a expiré',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-check',
            position: 'top-right'
          })
          this.$router.push({name: "page-login"})
        }
      })
    },
    toggleFilterPrompt(val = false) {
      this.filterPrompt = val;
    },
    toggleFilterPromptCode(val = false) {
      this.filterPromptCode = val;
    },
    parseFormat(amount){
      return format(amount)
    },
    parseDate(date){
      return moment(date).format('DD-MM-YYYY H:mm')
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/payments" +_buildQuery(this.model))
        .then((response) => {
          this.data = response.data.data;
          this.last_page = response.data.last_page;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
          this.$vs.notify({
            title: 'Erreur',
            text: 'Votre session a expiré',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-check',
            position: 'top-right'
          })
          this.$router.push({name: "page-login"})
        }
        });
    },
    getSpecialities(){
      this.$http
        .get("/specialities")
        .then((response) => {
          this.specialities = response.data;
          this.specialities.unshift({id: '', name: 'Tous'})
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAgent(){
      this.$vs.loading()
      this.$http
        .get("/agent/get")
        .then((response) => {
          this.agents = response.data;
          this.agents.unshift({id: '', name: 'Tous'})
          this.$vs.loading.close()
          this.toggleSidebar(true)
        })
        .catch((error) => {
          this.$vs.loading.close()
          console.log(error);
        });
    },
    getSearch() {
      if (this.model.search !=''){
        this.model.page = 1
        this.getData()
      }
    },
    getFilter() {
      this.model.page = 1
      this.getData()
    },

    reload(){
      this.model = { ...default_model }
      this.getData()
    },

    showDetail(element){
      this.information = { ...element}
      this.filterPrompt = true
    },
    reSendCode(){

    }
  }
}
</script>
<style lang="scss">
  .custom__card{
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
    border-radius: 6px;
    margin-bottom: 10px;
    padding: 20px;
  }
  .card__body{
    display: grid;
    min-height: 120px;
    height: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 10px;
  }
  @media only screen and (max-width: 740px) {
    .card__body{
      display: grid !important;
      grid-template-columns: 1fr !important;
      grid-auto-flow: row;
      height: auto !important;
      grid-gap: 10px !important;
    }
  }
</style>
